export default __webpack_public_path__ + "static/logo-7133c7d33a410632e303748007beadff.png";